const MUTATION_TYPE = {
  setOrganizations: 'setOrganizations',
  setRoles: 'setRoles',
  setOlympics: 'setOlympics',
  setLink: 'setLink',
  setExpertExampleLink: 'setExpertExampleLink',
  fixClassNames: 'fixClassNames'
}

const ACTION_TYPE = {
  fetchOrganizations: 'fetchOrganizations',
  fetchRoles: 'fetchRoles',
  fetchOlympics: 'fetchOlympics',
  fetchLink: 'fetchLink',
  changePage: 'changePage',
  fetchExpertExampleLink: 'fetchExpertExampleLink',
  changePageSize: 'changePageSize'
}

const GETTER_TYPE = {
  getOrganizations: 'getOrganizations',
  getRoles: 'getRoles',
  getOlympics: 'getOlympics',
  getLink: 'getLink',
  getClasses: 'getClasses',
  getExpertExampleLink: 'getExpertExampleLink'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
